import React from "react";
import styled from "styled-components";
import performanceGrid from "./speaker.png";

const PerformanceGrid: React.FC = () => {
  return (
    <PerformanceGridContainer id="performance-grid">
      <img
        src={performanceGrid}
        alt="Performance Grid"
        style={{ width: "100%", maxWidth: "140px", height: "auto" }}
      />
    </PerformanceGridContainer>
  );
};

export default PerformanceGrid;

// Styled Components
const PerformanceGridContainer = styled.div.attrs({
  id: "performance-grid-container",
})`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 140px;
  max-width: 140px;
  flex-shrink: 0;
  align-self: stretch;
  padding: 16px 8px;
`;
